import React, { useState, useEffect } from 'react'
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
} from "recharts";
import './LineChartThree.css'

const LineChartThree = ({ data, userType }) => {
  // console.log("data>>>>>> ", data);
  
  // Initialize series with default values or API data
  const [series, setSeries] = useState([0, 0])
  const [chartData, setChartData] = useState([])

  // Transform API data to match the sampledata structure
  useEffect(() => {
    if (data && data.length >= 2) {
      // Convert string values to numbers and round them
      const expensePercent = Math.round(parseFloat(data[0]) || 0);
      const profitPercent = Math.round(parseFloat(data[1]) || 0);
      
      setSeries([expensePercent, profitPercent]);

      // Create chart data that matches the sampledata structure
      // Using the existing sample data pattern but with your API values
      const transformedData = [
        { 
          name: 'Q1',
          value1: Math.round(expensePercent * 0.2),  // 20% of actual
          value2: Math.round(profitPercent * 0.2)    // 20% of actual
        },
        { 
          name: 'Q2',
          value1: Math.round(expensePercent * 0.4),  // 40% of actual
          value2: Math.round(profitPercent * 0.4)    // 40% of actual
        },
        { 
          name: 'Q3',
          value1: Math.round(expensePercent * 0.7),  // 70% of actual
          value2: Math.round(profitPercent * 0.7)    // 70% of actual
        },
        { 
          name: 'Current',
          value1: expensePercent,  // 100% of actual
          value2: profitPercent     // 100% of actual
        }
      ];

      setChartData(transformedData);
    }
  }, [data])

  // Use chartData if available, otherwise fall back to sampledata
  const displayData = chartData.length > 0 ? chartData : [
    { name: 'Q1', value1: 12, value2: 8 },
    { name: 'Q2', value1: 45, value2: 29 },
    { name: 'Q3', value1: 70, value2: 25 },
    { name: 'Current', value1: 53, value2: 20 },
  ];

  // Custom Tooltip Component
  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div className="custom-tooltip-ln3">
          <div className="tooltip-header">{label}</div>
          <div className="tooltip-content">
            <div className="tooltip-item">
              <span className="tooltip-dot expense-dot"></span>
              <span className="tooltip-label">Expense:</span>
              <span className="tooltip-value">{payload[0]?.value}%</span>
            </div>
            <div className="tooltip-item">
              <span className="tooltip-dot profit-dot"></span>
              <span className="tooltip-label">Profit:</span>
              <span className="tooltip-value">{payload[1]?.value}%</span>
            </div>
          </div>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="chart-main-ln3">
      <div className="chart-card-ln3">
        <div className="chart-container-ln3">
          <ResponsiveContainer width="100%" height={320}>
            <LineChart data={displayData}>
              <CartesianGrid
                vertical={false}
                strokeDasharray="5 5"
                stroke="#bfc6ce"
              />

              <XAxis hide />

              {/* 0 - 100 with gap of 10 */}
              <YAxis
                domain={[0, 100]}
                ticks={[0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100]}
                axisLine={false}
                tickLine={false}
              />

              <Tooltip 
                content={<CustomTooltip />}
                cursor={{ stroke: '#e2e8f0', strokeWidth: 1, strokeDasharray: '3 3' }}
              />

              <Line
                type="monotone"
                dataKey="value1"
                stroke="#102a3d"
                strokeWidth={3}
                dot={{ r: 6, fill: "#102a3d" }}
                activeDot={{ r: 8, fill: "#102a3d", stroke: "#fff", strokeWidth: 2 }}
              />

              {/* Profit line */}
              <Line
                type="monotone"
                dataKey="value2"
                stroke="#9a9a9a"
                strokeWidth={3}
                dot={{ r: 6, fill: "#9a9a9a" }}
                activeDot={{ r: 8, fill: "#9a9a9a", stroke: "#fff", strokeWidth: 2 }}
              />

            </LineChart>
          </ResponsiveContainer>

          <div className="custom-legend-ln3">
            <div className="legend-item-ln3">
              <span className="dot-exp-ln3"></span>
              Expense Percentage
            </div>

            <div className="legend-item-ln3">
              <span className="dot-prof-ln3"></span>
              Profit Percentage
            </div>
          </div>

          <div className="percentages-ln3">
            <p>{series[0]}%</p>
            <p>{series[1]}%</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default LineChartThree